module.exports = __webpack_public_path__ + "img/c26364821ea2ae51a27195d43bd5e19d.png";